import React, { useEffect, useState } from "react";
import "./Activities.scss";

import { useSelector } from "react-redux";
import { fetchActivityLogs } from "../../../api/organization";
import Loader from "../../../components/Loader/Loader";
import { format, isToday, isYesterday, parseISO } from "date-fns";

const Activities = () => {
  const { id: organization_id, name: organization_name } = useSelector(
    (state) => state.organizationReducer.value
  );

  const { id: branch_id } = useSelector((state) => state.branchReducer.value);

  const [accountLogs, setAccountLogs] = useState(null);
  const [loading, setLoading] = useState(false);

  const [selectedLog, setSelectedLog] = useState(null);

  const groupLogsByDate = (dataArray) => {
    const groups = dataArray.reduce((acc, log) => {
      const logDate = parseISO(log?.updated_at);
      let group = "";

      if (isToday(logDate)) {
        group = "Today";
      } else if (isYesterday(logDate)) {
        group = "Yesterday";
      } else {
        // group = format(orderDate, "dd/MM/yyyy hh:mm a");
        group = format(logDate, "dd/MM/yyyy");
      }

      if (!acc[group]) {
        acc[group] = [];
      }

      acc[group].push(log);
      return acc;
    }, {});

    return groups;
  };

  const getAccountActivities = () => {
    setLoading(true);
    fetchActivityLogs(organization_id, branch_id)
      .then((res) => {
        if (res.data?.length > 0) {
          const grouped_logs = groupLogsByDate(res.data);
          setAccountLogs(grouped_logs);
          //   setAccountLogs(null);
        } else {
          setAccountLogs(null);
        }
      })
      .catch((err) => {
        console.log("Error while fetching account logs activities.", err);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  useEffect(() => {
    getAccountActivities();
  }, [organization_id, branch_id]);

  return (
    <>
      {loading && <Loader />}
      <div className="account-activities">
        <p className="main-heading container-wrapper">
          Account Activities in {organization_name}
        </p>

        {accountLogs && (
          <div className="account-logs container-wrapper">
            {Object.keys(accountLogs).map((group, i) => {
              return (
                <div className="item-group" key={i}>
                  <p className="title">{group}</p>
                  <div className="lists">
                    {accountLogs[group]?.map((item, index) => {
                      return (
                        <div
                          className="item"
                          key={index}
                          onClick={() => {
                            setSelectedLog(item);
                          }}
                        >
                          <div className="left">
                            <p className="current">{item?.description}</p>
                            <p className="previous">
                              {item?.event} by {item?.causer?.name}.
                            </p>
                          </div>
                          <div className="right">
                            <p className="date">
                              {item?.updated_at
                                ? format(new Date(item?.updated_at), "hh:mm a")
                                : ""}
                            </p>
                          </div>
                        </div>
                      );
                    })}
                  </div>
                </div>
              );
            })}
          </div>
        )}
        {!accountLogs && (
          <div className="empty">
            <p>This organization has no logs.</p>
          </div>
        )}

        {selectedLog && (
          <div
            className="blur-back"
            onClick={() => {
              setSelectedLog(null);
            }}
          ></div>
        )}

        <IndividualActivity
          selectedLog={selectedLog}
          setSelectedLog={setSelectedLog}
        />
      </div>
    </>
  );
};

export default Activities;

export const IndividualActivity = ({ selectedLog }) => {
  const attributes = selectedLog?.properties?.attributes
    ? selectedLog?.properties?.attributes || {}
    : {};

  const [shouldRender, setShouldRender] = useState(false);

  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    if (selectedLog) {
      setShouldRender(true);
      setTimeout(() => {
        setIsVisible(true);
      }, 10);
    } else if (isVisible) {
      setIsVisible(false);
      setTimeout(() => {
        setShouldRender(false);
      }, 300);
    }
  }, [selectedLog, isVisible]);

  if (!shouldRender) return null;
  return (
    <div className={`individual-activity ${isVisible ? "active" : ""}`}>
      <p className="heading">
        {selectedLog?.log_name}
        <span>{`(${selectedLog?.event})`}</span>
      </p>

      {selectedLog?.event !== "deleted" && (
        <div className="attributes-list">
          <div className="item">
            <p>Description: </p>
            <span>{selectedLog?.description}</span>
          </div>
          {Object.entries(attributes)?.map(([key, value]) => {
            return (
              <div className="item" key={key}>
                <p>{key} : </p>
                <span>
                  {value === true ? "True" : value === false ? "False" : value}
                </span>
              </div>
            );
          })}
        </div>
      )}

      {selectedLog?.event === "deleted" && (
        <div className="deleted-tag">
          <p>This {selectedLog?.log_name} was deleted.</p>
          <span>{selectedLog?.description}</span>
          <span>Date: {selectedLog?.updated_at}</span>
        </div>
      )}
    </div>
  );
};
